import {memo} from 'react'

/** Single portal target ID for the copilot side panel content region */
export const COPILOT_SIDE_PANEL_CONTENT_ID = 'copilot-side-panel-content'

/**
 * Shell for the copilot side panel. Renders a portal target that
 * CopilotChatSidePanel renders into via `createPortal` in wide mode.
 */
export const CopilotSidePanelContent = memo(function CopilotSidePanelContentImpl() {
  return <div id={COPILOT_SIDE_PANEL_CONTENT_ID} className="height-full" />
})
